import './style.scoped.css';
import { Helmet } from 'react-helmet-async';
// import { Row } from 'react-bootstrap';
//import CookiesForm from '../../components/CookiesForm/CookiesForm';

interface ContentProps {
};

const DeklaracjaDostepnosci: React.FC<ContentProps> = ({}) => {
    return (
      <main className='content'>
        <Helmet>
          <title>Deklaracja dostępności - Teambit</title>
        </Helmet>
        {/* <CookiesForm/> */}
        <h1>Deklaracja dostępności</h1>

<section id="a11y-wstep">

    <p><span id="a11y-podmiot">Politechnika Opolska</span> zobowiązuje się zapewnić dostępność swojej <span id="a11y-zakres">strony internetowej</span> zgodnie z ustawą z dnia 4 kwietnia 2019 r. o dostępności cyfrowej stron internetowych i aplikacji mobilnych podmiotów publicznych.</p>

    <p>Deklaracja dostępności dotyczy strony internetowej <a className="btn btn-link links" id="a11y-url" href="https://teambit.po.opole.pl/">Studenckie Koło Naukowe TeamBIT Politechniki Opolskiej</a>.</p>

</section>

<ul>
<li>Data publikacji strony internetowej: <time id="a11y-data-publikacja" >26 sierpnia 2025 roku.</time></li>
<li>Data ostatniej istotnej aktualizacji: <time id="a11y-data-aktualizacja" >28 sierpnia 2025 roku.</time></li>
</ul>



<h2>Stan dostępności cyfrowej</h2>

<p id="a11y-status">Strona internetowa jest w pełni zgodna z załącznikiem do ustawy o dostępności cyfrowej z dnia 4 kwietnia 2019 r. o dostępności cyfrowej stron internetowych i aplikacji mobilnych podmiotów publicznych.</p>








<h2>Przygotowanie deklaracji dostępności i jej aktualizacja</h2>

<ul>
<li>Data sporządzenia deklaracji: <time id="a11y-data-sporzadzenie" >28 sierpnia 2025 roku.</time></li>
<li>Data ostatniego przeglądu deklaracji: <time id="a11y-data-przeglad" >28 sierpnia 2025 roku.</time></li>
</ul>


						<p>Deklarację sporządzono na podstawie samooceny przeprowadzonej przez podmiot publiczny w oparciu o <a className="btn btn-link links" href="https://www.gov.pl/attachment/1a3e2bb5-6d60-4897-ac2f-07a8e91e70ed">Listę kontrolną do badania dostępności cyfrowej strony internetowej - wersja 2.2 [DOCX, 120 KB]</a>.</p>
						<p>Wyniki badania przedstawia <a className="btn btn-link links" href="https://docs.google.com/document/d/1_9Ry85aB85-74yNbYHDXqAWRgfMPGpVD/edit?usp=sharing&ouid=111662695125404826267&rtpof=true&sd=true">Raport z audytu [COM/DOCUMENT/D/1_9RY85AB85-74YNBYHDXQAWRGFMPGPVD/EDIT?USP=SHARING&OUID=111662695125404826267&RTPOF=TRUE&SD=TRUE, 17 KB]</a>.</p>
						

 




<h2>Skróty klawiszowe</h2>

<p>Na stronie nie zastosowano żadnych specjalnych skrótów klawiaturowych.</p>
<p>Na stronie internetowej można używać standardowych skrótów klawiaturowych przeglądarki.</p>





<h2>Informacje zwrotne i dane kontaktowe</h2>

<p>Wszystkie problemy z dostępnością cyfrową tej strony internetowej możesz zgłosić do <span id="a11y-kontakt">Uczelnianego Ośrodka Informatycznego</span> mejlowo pisząc na adres <a className="btn btn-link links" id="a11y-email" href="mailto:dostepnosc-cyfrowa@po.edu.pl">dostepnosc-cyfrowa@po.edu.pl</a> lub telefonicznie dzwoniąc na numer telefonu <a className="btn btn-link links" href="tel:+48774498084" id="a11y-telefon">+48 77 449 80 84</a>. Tą samą drogą można składać wnioski o udostępnienie informacji niedostępnej oraz składać skargi na brak zapewnienia dostępności.</p>

<p>Każdy ma prawo wystąpić z żądaniem zapewnienia dostępności cyfrowej tej strony internetowej lub jej elementów.</p>

<p>Zgłaszając takie żądanie podaj:</p>
<ul>
<li>swoje imię i nazwisko,</li>
<li>swoje dane kontaktowe (np. numer telefonu, e-mail),</li>
<li>dokładny adres strony internetowej, na której jest niedostępny cyfrowo element lub treść,</li>
<li>opis na czym polega problem i jaki sposób jego rozwiązania byłby dla Ciebie najwygodniejszy.</li>
</ul>

<p>Na Twoje zgłoszenie odpowiemy najszybciej jak to możliwe, nie później niż w ciągu 7 dni od jego otrzymania.</p>

<p>Jeżeli ten termin będzie dla nas zbyt krótki poinformujemy Cię o tym. W tej informacji podamy nowy termin, do którego poprawimy zgłoszone przez Ciebie błędy lub przygotujemy informacje w alternatywny sposób. Ten nowy termin nie będzie dłuższy niż 2 miesiące.</p>

<p>Jeżeli nie będziemy w stanie zapewnić dostępności cyfrowej strony internetowej lub treści, wskazanej w Twoim żądaniu, zaproponujemy Ci dostęp do nich w alternatywny sposób.</p>


<section id="a11y-procedura">

	<h2>Obsługa wniosków i skarg związanych z dostępnością</h2>

    <p>Jeżeli w odpowiedzi na Twój wniosek o zapewnienie dostępności cyfrowej, odmówimy zapewnienia żądanej przez Ciebie dostępności cyfrowej, a Ty nie zgadzasz się z tą odmową, masz prawo złożyć skargę.</p>

	<p>Skargę masz prawo złożyć także, jeśli nie zgadzasz się na skorzystanie z alternatywnego sposobu dostępu, który zaproponowaliśmy Ci w odpowiedzi na Twój wniosek o zapewnienie dostępności cyfrowej.</p>

	<p>Ewentualną skargę złóż telefonicznie bądź mailowo do Uczelnianego Ośrodka Informatycznego (dane kontaktowe znajdują się powyżej).</p>
	
	<p>Pomocne mogą być informacje, które można znaleźć na rządowej stronie <a className="btn btn-link links" href="https://www.gov.pl/web/gov/zloz-wniosek-o-zapewnienie-dostepnosci-cyfrowej-strony-internetowej-lub-aplikacji-mobilnej">Złóż wniosek o zapewnienie dostępności cyfrowej strony internetowej lub aplikacji mobilnej (www.gov.pl)</a>.</p>

	<p>Możesz także poinformować o tej sytuacji <a className="btn btn-link links" href="https://bip.brpo.gov.pl/">Rzecznika Praw Obywatelskich</a> i poprosić o interwencję w Twojej sprawie.</p>

</section>



<h2>Pozostałe informacje</h2>

<p>Zapewniamy <a className="btn btn-link links" href="https://tlumacz.migam.org/politechnika_opolska">połączenie z tłumaczem Migam Obsługa osób niesłyszących</a>: pon.-pt. 08:00-20:00.</p>





<section id="a11y-architektura">

	<h3>Dostępność architektoniczna</h3>

	<ul> 
  <li> <a className="btn btn-link links" id="a11y-architektura-url" href="https://po.edu.pl/deklaracja-dostepnosci/dostepnosc-architektoniczna-ii-kampus-budynek-nr-7/">II Kampus - Budynek nr 7 (siedziba główna, Kancelaria Rektora), ul. Prószkowska 76</a> </li>
 <li> <a className="btn btn-link links" href="https://po.edu.pl/deklaracja-dostepnosci/dostepnosc-architektoniczna-ii-kampus-budynek-nr-5/">II Kampus - Budynek nr 5, ul. Prószkowska 76</a> </li>
 <li> <a className="btn btn-link links" href="https://po.edu.pl/deklaracja-dostepnosci/deklaracja-dostepnosci-dostepnosc-architektoniczna/">Lista wszystkich budynków</a> </li>
 </ul>

	<p>Brak rozwiązań w zakresie dostępności architektonicznej można zgłaszać do uczelnianego koordynatora dostępności, piszą na adres: <a className="btn btn-link links" href="mailto:koordynator-dostepnosci@po.edu.pl">koordynator-dostepnosci@po.edu.pl</a>.</p>

</section>




<section id="a11y-komunikacja">

	<h3>Dostępność komunikacyjno-informacyjna</h3>

	<p><a className="btn btn-link links" href="https://po.edu.pl/informacja-o-zakresie-dzialalnosci/">Informacje o Politechnice Opolskiej przygotowane w formacie łatwym do czytania i rozumienia (tzw. ETR)</a> oraz przetłumaczonych na polski język migowy znajdują się na stronie głównej Politechniki Opolskiej.</p>

	 <p>Serwis internetowy zapewnia podstawową dostępność komunikacyjno-informacyjną: kontakt możliwy jest przez telefon i e-mail, treści są publikowane w formie tekstowej. Strona częściowo spełnia wymagania WCAG 2.1 na poziomie AA.</p> 
 <p></p> 
 <p></p> 


	<p>Problemy w zakresie dostępności informacyjno-komunikacyjnej można zgłaszać do uczelnianego koordynatora dostępności, piszą na adres: <a className="btn btn-link links" href="mailto:koordynator-dostepnosci@po.edu.pl">koordynator-dostepnosci@po.edu.pl</a>.</p>

</section>
        {/* <h1 id="a11y-deklaracja">Deklaracja dostępności</h1>
        <p id="a11y-wstep">
            <span id="a11y-podmiot">Koło naukowe TeamBit Politechnika Opolska</span>
            zobowiązuje się zapewnić dostępność swojej strony internetowej zgodnie z przepisami ustawy z dnia 4 kwietnia 2019 r. o
            dostępności cyfrowej stron internetowych i aplikacji mobilnych podmiotów publicznych. Oświadczenie w sprawie dostępności
            ma zastosowanie do <div className="btn btn-link links" role="button" onClick={(e) => window.open("https://teambit.po.edu.pl", '_blank')} id="a11y-url">strony internetowej Teambit - koło naukowe Politechniki Opolskiej</div>.
        </p>
        <ul>
        <li>Data publikacji strony internetowej: <span id="a11y-data-publikacja">2025-08-26</span></li>
        <li>Data ostatniej istotnej aktualizacji: <span id="a11y-data-aktualizacja">2025-08-28</span></li>
        </ul>
        <h2>Status pod względem zgodności z ustawą</h2><p>Strona internetowa jest <span id="a11y-status">częściowo zgodna</span> z ustawą z dnia 4 kwietnia 2019 r. o dostępności cyfrowej stron internetowych i aplikacji mobilnych podmiotów publicznych z powodu niezgodności lub wyłączeń wymienionych poniżej.</p>
        <ul>
            <li>Strona internetowa nie posiada obsługi poruszania się za pomocą klawiatury.</li>

        </ul><p>Oświadczenie sporządzono dnia: <span id="a11y-data-sporzadzenie">2023-03-08</span>.</p><p>Deklarację sporządzono na podstawie samooceny przeprowadzonej przez podmiot publiczny.</p>
        <h2>Skróty klawiaturowe</h2>
        <p>Na stronie internetowej można używać standardowych skrótów klawiaturowych przeglądarki oraz takich skrótów: <ul><li>Na stronie nie zastosowano skrótów.</li>
        </ul></p>
        <h2 id="a11y-kontakt">Informacje zwrotne i dane kontaktowe</h2>
        <p>W przypadku problemów z dostępnością strony internetowej prosimy o kontakt.
            Osobą kontaktową jest <span id="a11y-osoba">Mirosław Gucwa</span>,
            <div className="btn btn-link links" role="button" onClick={(e) => window.open("mailto:m.gucwa@po.edu.pl")} id="a11y-email">m.gucwa@po.edu.pl</div>.
            Kontaktować można się także dzwoniąc na numer telefonu
            <span id="a11y-telefon">77 449 80 84</span>.
        Tą samą drogą można składać wnioski o udostępnienie informacji niedostępnej oraz składać skargi na brak zapewnienia dostępności.</p>

        <div id="a11y-procedura">
            <h2>Procedura wnioskowo-skargowa</h2>
            <p>Każdy ma prawo do wystąpienia z żądaniem zapewnienia dostępności cyfrowej strony internetowej, aplikacji mobilnej lub jakiegoś ich elementu.
            Można także zażądać udostępnienia informacji za pomocą alternatywnego sposobu dostępu, na przykład przez odczytanie niedostępnego cyfrowo dokumentu,
            opisanie zawartości filmu bez audiodeskrypcji itp.</p>

            <p>Żądanie powinno zawierać dane osoby zgłaszającej żądanie, wskazanie, o którą stronę internetową lub aplikację mobilną chodzi oraz sposób kontaktu.
            Jeżeli osoba żądająca zgłasza potrzebę otrzymania informacji za pomocą alternatywnego sposobu dostępu, powinna także określić dogodny
            dla niej sposób przedstawienia tej informacji.</p>

            <p>Podmiot publiczny powinien zrealizować żądanie niezwłocznie, nie później niż w ciągu 7 dni od dnia wystąpienia z żądaniem.
            Jeżeli dotrzymanie tego terminu nie jest możliwe, podmiot publiczny niezwłocznie informuje o tym wnoszącego żądanie, kiedy
            realizacja żądania będzie możliwa, przy czym termin ten nie może być dłuższy niż 2 miesiące od dnia wystąpienia z żądaniem.</p>

            <p>Jeżeli zapewnienie dostępności cyfrowej nie jest możliwe, podmiot publiczny może zaproponować alternatywny sposób dostępu do informacji.
            W przypadku, gdy podmiot publiczny odmówi realizacji żądania zapewnienia dostępności lub alternatywnego sposobu dostępu do informacji,
            wnoszący żądanie możne złożyć skargę w sprawie zapewniana dostępności cyfrowej strony internetowej, aplikacji mobilnej lub
            elementu strony internetowej, lub aplikacji mobilnej. Po wyczerpaniu wskazanej wyżej procedury można także złożyć wniosek
            do <div className="btn btn-link links" role="button" onClick={(e) => window.open("https://www.rpo.gov.pl/", '_blank')}>Rzecznika Praw Obywatelskich</div>.</p>
        </div>

        <h2 id="a11y-architektura">Dostępność architektoniczna</h2>
        <ul>
            <li><div className="btn btn-link links" role="button" onClick={(e) => window.open("https://www.po.opole.pl/deklaracja_dostepnosci/proszkowska_76_budynek_3", '_blank')}>II Kampus - Budynek nr 3: Wydział Elektrotechniki Automatyki i Informatyki (Katedra Automatyki i Informatyki)</div></li>

        </ul>
        <h2>Informacje dodatkowe</h2>
        <p>Zapewniamy <div className="btn btn-link links" role="button" onClick={(e) => window.open("https://tlumacz.migam.org/politechnika_opolska", '_blank')}>połączenie z tłumaczem Migam Obsługa osób niesłyszących</div>: pon.-pt. 08:00-20:00.</p>
     */} </main> 
    );
}
export default DeklaracjaDostepnosci;